<style scoped>
</style>

<template>
	<div class="vue-box">
		<div class="c-panel">

			<!-- 参数栏 -->
			<div class="c-title">今天课程列表</div>

			<!-- 数据列表 -->
			<div class="c-title">数据列表</div>
			<el-table :data="dataList" size="mini">
        <el-table-column label="课程状态" width="80px">
          <template slot-scope="s">
            <el-tag class="c-tag" effect="dark" size="mini" color="#282" v-if="s.row.status==0" @click="changeStatus(s.row.id,s.row.status)">未开始</el-tag>
            <el-tag class="c-tag" effect="dark" size="mini" color="#f22" v-if="s.row.status==1" @click="changeStatus(s.row.id,s.row.status)">已消课</el-tag>
          </template>
        </el-table-column>
				<el-table-column label="名称" prop="name"  width="200px"></el-table-column>

        <el-table-column label="老师" prop="teaName" width="100px"></el-table-column>
        <el-table-column label="上课时间" width="150px">
          <template slot-scope="s"><span>{{sa.forDate(s.row.time, 3)}}</span></template>
        </el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	export default {
		components: {
		},
		data() {
			return {
				dataList: [],		// 数据集合
			}
		},
		methods: {
			// 刷新
			f5: function(){
				this.sa.ajax('api/psdAdmin/clazzCard/getTodayClazzInfo',
            function(res){
				  if(res.code == 0) {
            this.dataList = res.data;	// 数据
          }else{
            this.dataList=[];
            this.sa.error(res.msg || '今天暂无课程');
          }
				}.bind(this)/*, {res: mockDataList}*/);
			},
		},
		created: function(){
			this.f5();
			// this.$notify.info({
			// 	title: '消息',
			// 	message: '本页面展示表格的常见显示方式'
			// });
		},
    filters: {

    }
	}
</script>
